// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._12ji1r31{outline-color:currentColor}
._12y3idpf{outline-width:0}
._1e0c1o8l{display:inline-block}
._1qu2glyw{outline-style:none}
._kqswh2mm{position:relative}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/avatar/dist/esm/avatar.compiled.css"],"names":[],"mappings":"AAAA,WAAW,0BAA0B;AACrC,WAAW,eAAe;AAC1B,WAAW,oBAAoB;AAC/B,WAAW,kBAAkB;AAC7B,WAAW,iBAAiB","sourcesContent":["._12ji1r31{outline-color:currentColor}\n._12y3idpf{outline-width:0}\n._1e0c1o8l{display:inline-block}\n._1qu2glyw{outline-style:none}\n._kqswh2mm{position:relative}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
